import React from 'react'

const CustomForm = ({ form, children, className }) => (
  <form name="customForm" onSubmit={form.handleSubmit} className={className}>
    {children}
  </form>
)

export default CustomForm
